import { Router } from '@angular/router';
import type { NotificationServiceType } from 'src/app/services/notifications.service';
import {
  navigateToInAppServiceOpen,
  notificationServiceTypeToApprovalService,
} from './in-app-list-deep-link.util';

/**
 * Opens the correct board (Labdips, Bulks, …) and the detail dialog for that entity.
 * Boards use the same `open*` query params as in-app email links; ACL is enforced by the API
 * when loading the list/detail (clients only see their brand scope).
 */
export function navigateFromNotification(
  router: Router,
  serviceType: NotificationServiceType,
  entityId: number
): Promise<boolean> {
  const approvalService = notificationServiceTypeToApprovalService(serviceType);
  if (!approvalService) {
    console.warn('Unknown notification service_type:', serviceType);
    return Promise.resolve(false);
  }
  return navigateToInAppServiceOpen(router, approvalService, entityId);
}
